import { TableSettingsFieldsTabType, TableSettingsTabType } from '@doss/common-all'
import { DEFAULT_FIELDS_TAB, DEFAULT_TAB } from './constants'
import { useTableColumnGroupMemberSelections } from './useTableColumnGroupMemberSelections'
import { useTableColumnSelections } from './useTableColumnSelections'

/**
 * Set of valid table settings tab types
 */
const validTableSettingsTabTypes = new Set<string>([
  TableSettingsTabType.CONFIGURATION,
  TableSettingsTabType.FIELDS,
  TableSettingsTabType.ACTIONS,
  TableSettingsTabType.EXPORTS,
  TableSettingsTabType.DEPENDENCIES,
])

/**
 * Set of valid table settings fields tab types
 */
const validTableSettingsFieldsTabTypes = new Set<string>([
  TableSettingsFieldsTabType.ALL_FIELDS,
  TableSettingsFieldsTabType.CHILD_TABLES,
  TableSettingsFieldsTabType.GROUPS,
  TableSettingsFieldsTabType.COMPOSITE_KEYS,
])

/**
 * Typeguard to check that tab string is valid table settings tab type
 */
const isTableSettingsTabType = (value: string): value is TableSettingsTabType => {
  return validTableSettingsTabTypes.has(value)
}

/**
 * Converts the query parameter to the TableSettingsTabType enum value
 */
export const getTabFromQuery = (tab: string | undefined): TableSettingsTabType => {
  if (tab && isTableSettingsTabType(tab)) {
    return tab
  }
  return DEFAULT_TAB
}

/**
 * Typeguard to check that tab string is valid table settings fields tab type
 */
const isTableSettingsFieldTabType = (value: string): value is TableSettingsFieldsTabType => {
  return validTableSettingsFieldsTabTypes.has(value)
}

/**
 * Converts the query parameter to the TableSettingsFieldsTabType enum value
 */
export const getFieldsTabFromQuery = (tab: string | undefined): TableSettingsFieldsTabType => {
  if (tab && isTableSettingsFieldTabType(tab)) {
    return tab
  }
  return DEFAULT_FIELDS_TAB
}

export const isTableColumnSelections = (
  selectionHelpers:
    | ReturnType<typeof useTableColumnSelections>
    | ReturnType<typeof useTableColumnGroupMemberSelections>,
): selectionHelpers is ReturnType<typeof useTableColumnSelections> => {
  return 'toggleColumnSelection' in selectionHelpers
}
